import React from 'react';
import {Routes, Route, useLocation} from 'react-router-dom'
import {useRoutePropagation} from '@shopify/app-bridge-react';


import MyDeliveries from "./pages/MyDeliveries";
import SendOrders from "./pages/SendOrders";
import ShopifyAppBridgeTest from "./pages/ShopifyAppBridgeTest";
import {GlobalSettingsStore} from "./contexts/settings";

export default function RoutesWithPropagation() {
    const location = useLocation();

    // Propagate route changes to the app bridge so the browser url is updated
    useRoutePropagation(location);

    return (
        <GlobalSettingsStore>
            <Routes>
                <Route path="/" element={<MyDeliveries />} />
                <Route path="/orders" element={<SendOrders />} />
                <Route path="/test" element={<ShopifyAppBridgeTest />} />
            </Routes>
        </GlobalSettingsStore>
    );
}
